import LazyLoad from 'vanilla-lazyload';
var LazyLoader = /** @class */ (function () {
    function LazyLoader() {
        this.lazyLoader = new LazyLoad();
    }
    LazyLoader.prototype.init = function () {
        new LazyLoad();
    };
    LazyLoader.prototype.update = function () {
        this.lazyLoader.update();
    };
    return LazyLoader;
}());
export { LazyLoader };
;
